<template>
    <div class="setting-wrapper">
        <div class="setting items-start">
            <h4 class="lg:w-1/5">Router</h4>
            <div class="font-bold text-sm text-neutral-darker lg:w-2/5">
                <div class="bg-neutral-lighter rounded-lg py-md px-lg flex items-center justify-start">
                    <div class="text-lg text-success mr-lg">
                        <font-awesome-icon icon="check-circle" />
                    </div>
                    <div class="max-w-xs text-sm font-semibold">
                        <span v-if="configurationData.hasCollectiveRouter">
                            {{ lang('Du har redan en router från Ownit','You already own a router from Ownit') }}.
                        </span>
                        <span v-else-if="configurationData.hasRouterInCart">
                            {{ lang('Du har redan en router tillagd i varukorgen','You already have a router in your cart') }}.
                        </span>
                        <span v-else-if="configurationData.customerHasRouter">
                            {{ lang('Du har redan en router från Ownit','You already own a router from Ownit') }}.
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            configurationData: {
                type: Object,
                required: true,
            },
        },
    };
</script>